// extracted by mini-css-extract-plugin
export default {"content":"VaillantPasswordReset_content__Z694G","main":"VaillantPasswordReset_main__0HFMe"};